module.exports = __webpack_public_path__ + "static/media/img_placeholder.2135e442.png";